import { useSelector } from 'react-redux';
import GlobalTable from '../../../components/CustomTableWithPagination/GlobalTable';
import GlobalWrapper from '../../../components/Wrapper/GlobalWrapper';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  getCrms,
  getFeeForecastData,
  getForecastConfig,
  getManualForecast,
} from '../../../redux/features/feeForecastSlice';
import { Box, Chip, MenuItem, TextField } from '@mui/material';
import { Icon } from '@iconify/react';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import AddExpectedSessions from './AddExpectedSessions';
import Config from './Config';
import { FORECAST_REGISTER_TBL_HEAD } from '../../../components/datagrid/myworkspace/finance/forecast/ForecastRegisterTblHead';
import AddForecastLogs from './AddForecastLogs';
import { AddButton } from '../../../components/mui/Buttons/Buttons';
import { getProjects } from '../../../redux/features/refundSlice';
import { getCROLists } from '../../../redux/features/CRDslice';
import BulkUpload from './BulkUpload';
import UpdateManualForecast from './UpdateManualForecast';

const FeeForecastRegister = () => {
  const [value, setValue] = useState(dayjs());
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const handleclick = (id, subject_name) => {
    window.open(`/my-workspace/academic-calendar-edit?subEnrollId=${id}&sub_name=${subject_name}`, '_blank');
  };
  const { feeForecast, loading, crmList } = useSelector((state) => state.feeForecast);
  const { meta, data } = feeForecast;
  const { allowedFilters } = meta || [];
  const [enrollId, setEnrollId] = useState(null);
  const { projectslist } = useSelector((state) => state.refund);
  const { croList } = useSelector((state) => state.crd);
  const [projectId, setProjectId] = useState('');
  const [filters, setFilters] = useState([]);
  const [crm, setCrm] = useState('');
  const [cro, setcro] = useState('');
  const [forecast, setForecast] = useState('');
  const [source, setSource] = useState('');
  const [currency, setCurrency] = useState('');
  const [threshold, setThreshold] = useState(0);

  function getMatchedFilters(validations, allowedFilters) {
    return validations?.filter((item) => allowedFilters?.includes(item));
  }

  useEffect(() => {
    const validations = ['project', 'crm', 'cro'];
    const filter = getMatchedFilters(validations, allowedFilters);
    setFilters(filter);
  }, [allowedFilters]);
  const handleChangeCro = (e) => {
    setcro(e.target.value);
  };
  const handleChange = (event) => {
    setCrm('');
    setProjectId(event.target.value);
    dispatch(getCrms(event.target.value));
  };
  const handleChangeCrm = (e) => {
    setcro('');
    setCrm(e.target.value);
    dispatch(getCROLists(e.target.value));
  };
  const handleOpen = (id) => {
    setEnrollId(id);
    setOpen(true);
  };
  const forecastType = [
    { id: 0, name: 'ALL' },
    { id: 1, name: 'MANUAL' },
    { id: 2, name: 'OPTION' },
    { id: 3, name: 'PERCENTAGE' },
  ];
  const finalSource = [
    { id: 0, name: 'ALL' },
    { id: 1, name: 'CRO' },
    { id: 2, name: 'CRM' },
    { id: 3, name: 'FINANCE' },
    { id: 4, name: 'SYSTEM' },
  ];
  const currencyType = [
    { id: 0, name: 'All' },
    { id: 1, name: 'INR' },
    {
      id: 2,
      name: 'AED',
    },
    { id: 3, name: 'AED to INR' },
  ];

  const thresholdData = [
    { id: 0, name: 'ALL' },
    { id: 1, name: 'Below Threshold' },
  ];

  const handleThreshold = (e) => {
    setThreshold(e.target.value);
  };

  const handleChangeForecast = (e) => {
    setForecast(e.target.value);
  };
  const handleSource = (e) => {
    setSource(e.target.value);
  };
  const handleCurrency = (e) => {
    setCurrency(e.target.value);
  };
  const [tableState, setTableState] = useState({
    page: 1,
    pageSize: 50,
    search: '',
    sort: { field: '', direction: '' },
    frozenColumns: [],
    checkedRowIds: [],
    hiddenColumns: [],
  });

  const dispatchParams = useMemo(() => {
    return {
      page: tableState?.page,
      limit: tableState?.pageSize,
      search: tableState?.search,
      date: dayjs(value).format('YYYY-MM-DD'),
      sortKey: tableState.sort.field,
      sortDir: tableState.sort.direction,
      project: projectId,
      crm: crm,
      cro: cro,
      forecast_typeName: forecast,
      final_source: source,
      currency_type: currency,
      threshold: threshold,
    };
  }, [
    tableState?.page,
    tableState?.pageSize,
    tableState?.search,
    value,
    tableState.sort.field,
    tableState.sort.direction,
    projectId,
    crm,
    cro,
    forecast,
    source,
    currency,
    threshold,
  ]);

  const hardRefreshParams = useMemo(() => ({ ...dispatchParams, hardRefresh: true }), [dispatchParams]);

  const handleRefresh = () => {
    dispatch(getFeeForecastData(hardRefreshParams));
  };
  const columns = [
    ...FORECAST_REGISTER_TBL_HEAD,
    {
      field: 'Subjects',
      headerName: 'Subjects',
      width: 200,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => {
        if (params.row.subjects.length == 0) {
          return 'No subjects enrolled';
        }
        const isCalender = params.row.subjects.every((item) => item.is_calendar_created === true);
        const sessions = params.row.forecast?.final_sessions;
        return (
          <Box>
            {params.row.subjects.map((item) => {
              return (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', m: 0.5 }}>
                  <Chip
                    icon={<Icon icon="ep:edit" width="10" height="10" />}
                    onClick={() => (isCalender ? handleclick(item.subject_enrollment_id, item.subject_name) : null)}
                    label={item.subject_name || 'Not Available'}
                    disabled={meta?.isDeadlinePassed}
                    variant={item.is_calendar_created ? 'contained' : 'outlined'}
                    color="primary"
                    sx={{ fontSize: 10, height: 20, minWidth: 160 }}
                  />
                </Box>
              );
            })}
            <Box>
              {' '}
              <AddExpectedSessions
                date={value}
                isDisabled={meta?.isDeadlinePassed}
                enrollId={params.row.course_enrollment_id}
                isCalendar={isCalender}
                finalSessions={sessions}
                dispatchParams={dispatchParams}
              />
            </Box>
          </Box>
        );
      },
    },
    {
      field: 'final_sessions',
      headerName: 'Final Sessions',
      width: 140,
      align: 'center',
      headerAlign: 'center',
      valueGetter: (params) => params.row.forecast?.final_sessions,
      sortable: true,
    },
    {
      field: 'forecast_status',
      headerName: 'Forecast Status',
      width: 140,
      align: 'center',
      headerAlign: 'center',
      valueGetter: (params) => params.row.forecast?.status,
      sortable: true,
    },
    {
      field: 'status',
      headerName: 'Final Source',
      width: 140,
      align: 'center',
      headerAlign: 'center',
      valueGetter: (params) => params.row.forecast?.final_source,
    },

    {
      field: 'Logs',
      headerName: 'Add Logs',
      width: 140,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => {
        return (
          <AddButton
            disabled={params.row.forecast_typeName == 'MANUAL' ? false : true}
            size={'small'}
            action={() => handleOpen(params.row.course_enrollment_id)}
          >
            Add Logs
          </AddButton>
        );
      },
    },
  ];

  const profile = JSON.parse(localStorage.getItem('cred')).profile;
  useEffect(() => {
    dispatch(getFeeForecastData(dispatchParams));
  }, [dispatch, dispatchParams]);
  useEffect(() => {
    dispatch(getForecastConfig());
    dispatch(getProjects());
    dispatch(getManualForecast());
  }, [dispatch]);
  useEffect(() => {
    if (filters.length == 1) {
      // setCrm(profile.userId);
      dispatch(getCROLists(profile.userId));
    }
  }, [filters]);
  return (
    <GlobalWrapper
      title={'Fee Forecast Register'}
      actions={
        <Box>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              views={['year', 'month']}
              value={value}
              onChange={(newValue) => setValue(newValue)}
              format="MMM YYYY"
              slotProps={{
                textField: {
                  size: 'small',
                  fullWidth: true,
                },
              }}
            />
          </LocalizationProvider>
        </Box>
      }
    >
      <Box sx={{ pb: 2, display: 'flex', gap: 3, flexWrap: 'wrap' }}>
        {filters.includes('project') && (
          <Box>
            <TextField
              sx={{ minWidth: 150 }}
              select
              label="Project"
              size="small"
              value={projectId}
              onChange={handleChange}
              fullWidth
            >
              {projectslist.map((project) => (
                <MenuItem key={project.id} value={project.id}>
                  {project.name}
                </MenuItem>
              ))}
            </TextField>
          </Box>
        )}

        {filters.includes('crm') && (
          <Box>
            <TextField
              sx={{ minWidth: 150 }}
              select
              label="CRM"
              size="small"
              value={crm}
              onChange={handleChangeCrm}
              fullWidth
            >
              {crmList.map((crm) => (
                <MenuItem key={crm.crmId} value={crm.crmId}>
                  {crm.crmName}
                </MenuItem>
              ))}
            </TextField>
          </Box>
        )}

        {filters.includes('cro') && (
          <Box>
            <TextField
              sx={{ minWidth: 150 }}
              select
              label="CRO"
              size="small"
              value={cro}
              onChange={handleChangeCro}
              fullWidth
            >
              {croList.map((cro) => (
                <MenuItem key={cro.userID} value={cro.userID}>
                  {cro.name}
                </MenuItem>
              ))}
            </TextField>
          </Box>
        )}
        <Box>
          <TextField
            sx={{ minWidth: 150 }}
            select
            label="Forecast type"
            size="small"
            value={forecast}
            onChange={handleChangeForecast}
            fullWidth
          >
            {forecastType.map((forecast) => (
              <MenuItem key={forecast.id} value={forecast.name}>
                {forecast.name}
              </MenuItem>
            ))}
          </TextField>
        </Box>
        <Box>
          <TextField
            sx={{ minWidth: 150 }}
            select
            label="Final Source"
            size="small"
            value={source}
            onChange={handleSource}
            fullWidth
          >
            {finalSource.map((source) => (
              <MenuItem key={source.id} value={source.name}>
                {source.name}
              </MenuItem>
            ))}
          </TextField>
        </Box>
        <Box>
          <TextField
            sx={{ minWidth: 150 }}
            select
            label="Currency Type"
            size="small"
            value={currency}
            onChange={handleCurrency}
            fullWidth
          >
            {currencyType.map((currency) => (
              <MenuItem key={currency.id} value={currency.id}>
                {currency.name}
              </MenuItem>
            ))}
          </TextField>
        </Box>
        <Box>
          <TextField
            sx={{ minWidth: 150 }}
            select
            label="Below Threshold"
            size="small"
            value={threshold}
            onChange={handleThreshold}
            fullWidth
          >
            {thresholdData.map((threshold) => (
              <MenuItem key={threshold.id} value={threshold.id}>
                {threshold.name}
              </MenuItem>
            ))}
          </TextField>
        </Box>
      </Box>
      {profile?.departmentId == 7 ? (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', m: 1, gap: 2 }}>
          <Config />
          <BulkUpload dispatchParams={dispatchParams} />
        </Box>
      ) : null}

      <GlobalTable
        headers={columns}
        loading={loading}
        meta={meta}
        rows={data}
        exportParams={{ ...dispatchParams, page: 1, limit: 'no' }}
        exportApi={getFeeForecastData}
        tableState={tableState}
        setTableState={setTableState}
        handleRefresh={handleRefresh}
        rowUniqueId="course_enrollment_id"
      />
      <AddForecastLogs enrollId={enrollId} setEnrollId={setEnrollId} open={open} setOpen={setOpen} />
    </GlobalWrapper>
  );
};

export default FeeForecastRegister;
